export class EventTypes {
	static dispatch: any;

	static MESSAGE = {
		SNACK: 'SNACK'
	};

	static MENU = {
		TOGGLE: 'TOGGLE',
		CHANGE: 'CHANGE'
	};

	static PROFILE = {
		TOGGLE: 'TOGGLE',
		NOTIFICATIONS: 'NOTIFICATIONS',
	};

	static TERMS = {
		TERMS: 'TERMS'
	};

	static MODAL_ERROR = {
		MODAL_ERROR: 'MODAL_ERROR',
		MODAL_CLOSE: 'MODAL_CLOSE'
	};

	static MODAL_WARNING = {
		MODAL_WARNING: 'MODAL_WARNING',
		MODAL_CLOSE: 'MODAL_CLOSE'
	};

	static EXPORT_BUTTONS = {
		DATA_TRANSACTION: 'DATA_TRANSACTION',
		DATA_REPORT_INCOME: 'DATA_REPORT_INCOME'
	};

	static PRELOAD = 'PRELOAD';
	static BALANCE = 'BALANCE';
	static EXTRACT_TABLE_TOGGLE_BALANCE = 'EXTRACT_TABLE_TOGGLE_BALANCE';

	static CUSTUMER_SERVICE_INFO = 'CUSTUMER_SERVICE_INFO';

	static MODAL_ANSWER = {
		MODAL_ANSWER: 'MODAL_ANSWER',
		MODAL_CLOSE: 'MODAL_CLOSE'
	};

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/EventTypes.ts